/**
 * Application purpose codes for 601 applications. All applications that originate in our
 * system will be one of these types.
 */
export enum ApplicationPurposeCodeEnum {
    modification = 'MD',
    new = 'NE',
    constructionNotification = 'NT',
    renewalOrModification = 'RM',
    renewalOnly = 'RO',
    other = 'OT',

    // Unsupported
    amendment = 'AM',
    administrativeUpdate = 'AU',
    cancellation = 'CA',
    withdrawal = 'WD',
}

/**
 * These are purpose codes that are considered existing license applications.
 */
export const ExistingLicenseApplicationPurposeCodes: ApplicationPurposeCodeEnum[] =
    [
        ApplicationPurposeCodeEnum.modification,
        ApplicationPurposeCodeEnum.renewalOrModification,
        ApplicationPurposeCodeEnum.renewalOnly,
    ];

/**
 * Unsupported purposes that CEVO does not process.
 */
export const UnsupportedApplicationPurposeCodes =
    new Set<ApplicationPurposeCodeEnum>([
        ApplicationPurposeCodeEnum.amendment,
        ApplicationPurposeCodeEnum.administrativeUpdate,
        ApplicationPurposeCodeEnum.cancellation,
        ApplicationPurposeCodeEnum.withdrawal,
    ]);

/**
 * Purpose codes for applications allowed to be submitted to PSCA.
 */
export const PublicSafetyApplicationPurposeCodes =
    new Set<ApplicationPurposeCodeEnum>([
        ApplicationPurposeCodeEnum.new,
        ApplicationPurposeCodeEnum.renewalOrModification,
        ApplicationPurposeCodeEnum.modification,
    ]);

/**
 * Application purpose code labels for display in the UI.
 */
export const ApplicationPurposeCodeLabelMapping = {
    [ApplicationPurposeCodeEnum.modification]: 'Modification',
    [ApplicationPurposeCodeEnum.new]: 'New',
    [ApplicationPurposeCodeEnum.constructionNotification]:
        'Construction Notification',
    [ApplicationPurposeCodeEnum.renewalOrModification]: 'Renewal/Modification',
    [ApplicationPurposeCodeEnum.renewalOnly]: 'Renewal Only',
    [ApplicationPurposeCodeEnum.other]: 'Other',
    [ApplicationPurposeCodeEnum.amendment]: 'Amendment',
    [ApplicationPurposeCodeEnum.administrativeUpdate]: 'Administrative Update',
    [ApplicationPurposeCodeEnum.cancellation]: 'Cancellation of License',
    [ApplicationPurposeCodeEnum.withdrawal]: 'Withdrawal of Application',
};

/**
 * Checks to see if the purpose code is unsupported.
 */
export const isUnsupportedPurpose = (
    code?: ApplicationPurposeCodeEnum | null,
): boolean => code != null && UnsupportedApplicationPurposeCodes.has(code);
